import server from "@/utils/request";


// 发请求的操作封装成函数  mock

// 配置
export function getConfig(data){
    return server({
        method:"GET",
        url:"/api/common/getConfig",
        params: data
    })
}

// 获取OSS CDN域名
export function getCdnUrl(){
    return server({
        method:"GET",
        url:"/api/common/getCdnUrl",
    })
}

// 企业动态分类
export function getNewsClass(data){
    return server({
        method:"GET",
        url:"/api/article/getCategory",
        params: data
    })
}
// 企业动态列表
export function getNewsList(data){
    return server({
        method:"GET",
        url:"/api/article/index",
        params: data
    })
}

// 产品分类
export function productClass(data){
    return server({
        method:"GET",
        url:"/api/goods/productCategory",
        params: data
    })
}
// 产品列表
export function productList(data){
    return server({
        method:"GET",
        url:"/api/goods/productGoods",
        params: data
    })
}

// 员工风采
export function getStaffList(data){
    return server({
        method:"GET",
        url:"/api/article/getStaff",
        params: data
    })
}
// 工厂风采
export function getFactorysList(data){
    return server({
        method:"GET",
        url:"/api/article/getFactorys",
        params: data
    })
}

// 注册
export function getRegister(data){
    return server({
        method:"POST",
        url:"/api/user/register",
        data
    })
}
// 验证码
export function getCode(data){
    return server({
        method:"POST",
        url:"/api/sms/send",
        data
    })
}
// 登录
export function getLogin(data){
    return server({
        method:"POST",
        url:"/api/user/pcLogin",
        data
    })
}
// 找回密码
export function FindPwd(data){
    return server({
        method:"POST",
        url:"/api/user/retrievePassword",
        data
    })
}
// 退出登录
export function loginOut(data){
    return server({
        method:"POST",
        url:"/api/user/logout",
        data
    })
}
// 用户
export function getUserInfo(data){
    return server({
        method:"GET",
        url:"/api/user/info",
        params: data
    })
}
// 修改资料
export function updateUser(data){
    return server({
        method:"POST",
        url:"/api/user/update",
        data
    })
}

// 商城轮播图
export function getShopBanner(data){
    return server({
        method:"GET",
        url:"/api/banner/index",
        params: data
    })
}
// 商品全部分类
export function goodsAllCategory(data){
    return server({
        method:"GET",
        url:"/api/goods/allCategory",
        params: data
    })
}
// 商品分类
export function goodsCategory(data){
    return server({
        method:"GET",
        url:"/api/goods/getCategory",
        params: data
    })
}
// 商品
export function getGoods(data){
    return server({
        method:"GET",
        url:"/api/goods/index",
        params: data
    })
}
// 商品详情
export function getGoodsInfo(data){
    return server({
        method:"GET",
        url:"/api/goods/info",
        params: data
    })
}
// 收藏
export function collectGoods(data){
    return server({
        method:"POST",
        url:"/api/goods/collect",
        data
    })
}
// 商品评价
export function getGoodsComment(data){
    return server({
        method:"GET",
        url:"/api/comment/index",
        params: data
    })
}
// 获取配送费
export function getOrderFee(data){
    return server({
        method:"POST",
        url:"/api/order/getOrderFee",
        data
    })
}
// 确认订单页面
export function getOrderData(data){
    return server({
        method:"POST",
        url:"/api/order/getOrderData",
        data
    })
}
// 下单
export function createOrder(data){
    return server({
        method:"POST",
        url:"/api/order/create",
        data
    })
}
// 支付
export function payOrder(data){
    return server({
        method:"GET",
        url:"/api/order/pay",
        params: data
    })
}

// 订单数量
export function orderCount(data){
    return server({
        method:"GET",
        url:"/api/order/orderCount",
        params: data
    })
}
// 订单列表
export function orderList(data){
    return server({
        method:"GET",
        url:"/api/order/index",
        params: data
    })
}
// 订单详情
export function orderInfo(data){
    return server({
        method:"GET",
        url:"/api/order/info",
        params: data
    })
}
// 修改地址
export function changeAddrOrder(data){
    return server({
        method:"POST",
        url:"/api/order/editAddress",
        data
    })
}
// 取消订单
export function cancelOrder(data){
    return server({
        method:"GET",
        url:"/api/order/cancel",
        params: data
    })
}
// 删除订单
export function delOrder(data){
    return server({
        method:"GET",
        url:"/api/order/del",
        params: data
    })
}
// 收货
export function deliveryOrder(data){
    return server({
        method:"GET",
        url:"/api/order/delivery",
        params: data
    })
}
// 评价
export function commentOrder(data){
    return server({
        method:"POST",
        url:"/api/comment/create",
        data
    })
}
// 申请售后
export function refundOrder(data){
    return server({
        method:"POST",
        url:"/api/order/refund",
        data
    })
}
// 售后 物流公司
export function logisticsNames(data){
    return server({
        method:"GET",
        url:"/api/common/getLogisticsNames",
        params: data
    })
}
// 提交回寄信息
export function sendingPackage(data){
    return server({
        method:"POST",
        url:"/api/order/sendingPackage",
        data
    })
}
// 撤销售后
export function revokeRefund(data){
    return server({
        method:"GET",
        url:"/api/order/revokeRefund",
        params: data
    })
}
// 售后订单详情
export function refundInfo(data){
    return server({
        method:"GET",
        url:"/api/order/getRefund",
        params: data
    })
}

// 可领券优惠券
export function getCouponList(data){
    return server({
        method:"GET",
        url:"/api/coupon/index",
        params: data
    })
}
// 领取优惠券
export function payCoupon(data){
    return server({
        method:"GET",
        url:"/api/coupon/pay",
        params: data
    })
}
// 我的优惠券
export function getMyCoupon(data){
    return server({
        method:"GET",
        url:"/api/coupon/list",
        params: data
    })
}

// 增加修改购物车
export function addOrEditCart(data){
    return server({
        method:"POST",
        url:"/api/cart/addOrEditCart",
        data
    })
}
// 购物车
export function getCartList(data){
    return server({
        method:"GET",
        url:"/api/cart/index",
        params: data
    })
}
// 删除购物车
export function delCart(data){
    return server({
        method:"GET",
        url:"/api/cart/del",
        params: data
    })
}

// 新增编辑地址
export function addOrEditAddress(data){
    return server({
        method:"POST",
        url:"/api/address/addOrEditAddress",
        data
    })
}
// 我的地址
export function getAddressList(data){
    return server({
        method:"POST",
        url:"/api/address/getAddress",
        data
    })
}
// 地址详情
export function getAddressInfo(data){
    return server({
        method:"POST",
        url:"/api/address/getAddressById",
        data
    })
}
// 删除地址
export function delAddress(data){
    return server({
        method:"POST",
        url:"/api/address/delAddress",
        data
    })
}

// 图形验证码
export function getCaptcha(data){
    return server({
        method:"GET",
        url:"/api/common/captcha",
        params: data
    })
}
// 修改密码
export function updatePassword(data){
    return server({
        method:"POST",
        url:"/api/user/updatePassword",
        data
    })
}

// 设置 分类
export function settingCategory(data){
    return server({
        method:"GET",
        url:"/api/news/getCategory",
        params: data
    })
}
// 设置 列表
export function settingList(data){
    return server({
        method:"GET",
        url:"/api/news/index",
        params: data
    })
}
// 设置 详情
export function settingInfo(data){
    return server({
        method:"GET",
        url:"/api/news/info",
        params: data
    })
}
// 我的收藏
export function myCollectGoods(data){
    return server({
        method:"GET",
        url:"/api/goods/myCollect",
        params: data
    })
}
// 浏览记录
export function myHistorysGoods(data){
    return server({
        method:"GET",
        url:"/api/goods/historys",
        params: data
    })
}
// 删除浏览记录
export function delHistorysGoods(data){
    return server({
        method:"POST",
        url:"/api/goods/delHistorys",
        data
    })
}

// 分享小程序码
export function qrCode(data){
    return server({
        method:"GET",
        url:"/api/user/getShareQrCode",
        params: data
    })
}
// 佣金明细 提现明细
export function myBalance(data){
    return server({
        method:"GET",
        url:"/api/user/balance",
        params: data
    })
}
// 提现
export function withdrawal(data){
    return server({
        method:"POST",
        url:"/api/user/withdrawal",
        data: data
    })
}
// 我的下级
export function myJunior(data){
    return server({
        method:"GET",
        url:"/api/user/junior",
        params: data
    })
}



// 申请开票
export function applyInvoice(data){
    return server({
        method:"POST",
        url:"/api/invoice/apply",
        data
    })
}
// 我的发票列表
export function getInvoiceList(data){
    return server({
        method:"GET",
        url:"/api/invoice/list",
        params: data
    })
}
// 发票详情
export function getInvoiceDetail(data){
    return server({
        method:"GET",
        url:"/api/invoice/detail",
        params: data
    })
}

// 首页轮播
export function indexBanner(data){
    return server({
        method:"GET",
        url:"/api/banner/pcindex",
        params: data
    })
}
// 四大产品
export function fourBanner(data){
    return server({
        method:"GET",
        url:"/api/banner/pcproduct",
        params: data
    })
}
// 广告位
export function adBanner(data){
    return server({
        method:"GET",
        url:"/api/banner/pcbanner",
        params: data
    })
}


